import { render, staticRenderFns } from "./Archives.vue?vue&type=template&id=42d7c2fd"
import script from "./Archives.vue?vue&type=script&lang=js"
export * from "./Archives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports